import React from "react";
import cx from "classnames";
import s from "./logo.scss";
import { view } from "@risingstack/react-easy-state";
import sessionStore from "@/stores/session";

const getDefaultLogo = () => {
  const env = process.env.NODE_ENV;

  if (env === "staging") {
    return `${BASE_URL_PUBLIC_ASSETS}/logo_panel_staging.svg`;
  } else if (env === "development") {
    return `${BASE_URL_PUBLIC_ASSETS}/logo_panel_dev.svg`;
  } else if (env === "production" && location.hostname === "sandbox.qboxmail.com") {
    // is sandbox
    return `${BASE_URL_PUBLIC_ASSETS}/logo_panel_sandbox.svg`;
  }

  return `${BASE_URL_PUBLIC_ASSETS}/logo_panel.svg`;
};

class Logo extends React.Component {
  state = {
    forceWhitelabel: false,
    defaultLogo: getDefaultLogo(),
  };

  handleError = () => {
    sessionStore.customization.logo = this.state.defaultLogo;
  };

  render() {
    const { className, onClick } = this.props;
    const logo = sessionStore.customization?.logo;

    const logoSrc = logo ? `${BASE_URL_PUBLIC_ASSETS}${logo}` : this.state.defaultLogo;

    return (
      <div className={cx(className, s.logo)}>
        <img onClick={onClick} alt="logo" title="logo" onError={this.handleError} src={logoSrc} />
      </div>
    );
  }
}

export default view(Logo);
